{
    "nav": {
        "home": "Dashboard",
        "requests": "Requests",
        "family": "My family",
        "menu": "Menu",
        "settings": "Settings",
        "contactUs": "Contact us",
        "signOut": "Sign out"
    },
    "screens": {
        "leaveRequest": "Leave request",
        "medicalRequest": "Medical request",
        "pickupRequest": "Pickup request",
        "absences": "Absences",
        "pickups": "Pickup requests",
        "leaveDays": "No pickup days",
        "selectOption": "Select option"
    },
    "login": {
        "welcome": "Welcome to BASIS Prague",
        "continueWithSchool": "Use your school account to continue",
        "signInFailed": "Sign-in failed",
        "unknownError": "Unknown error",
        "unlocking": "Unlocking…",
        "unlockWith": "Unlock with {{method}}",
        "signingIn": "Signing in…",
        "signInWithSchool": "Sign in with school account",
        "microsoft": {
            "errors": {
                "canceled": "Microsoft sign-in was canceled.",
                "not-completed": "Microsoft sign-in was not completed.",
                "no-id-token": "Microsoft sign-in failed. Missing ID token."
            }
        },
        "getTheAppOnYourPhone": "Get the app on your phone",
        "downloadOnTheAppStore": "Download on the App Store",
        "getItOnGooglePlay": "Get it on Google Play"
    },
    "home": {
        "title": "School dashboard",
        "requestsTitle": "Quick requests",
        "requestsDescription": "Create a leave, medical, or pickup request for your child.",
        "requestLeave": "Leave",
        "requestMedical": "Medical",
        "requestPickup": "Pickup",
        "medicalNoteCount": "Medical note",
        "medicalNotesCount": "Medical notes",
        "walksHome": "Walks home on {{days}}",
        "pickupRequiredAlways": "Pickup required every day",
        "pickupChange": "Pickup change",
        "pickupRowSubtitle": "{{date}} · {{picker}}",
        "pickupRecurringRowSubtitle": "Every {{days}} · {{from}} – {{to}} · {{picker}}",
        "noStudents": "No students are registered with your account.",
        "students": "Students",
        "student": "Student",
        "studentsDescription": "Open leave or pickup requests for a student.",
        "leaveRequests": "Absences",
        "leaveNeedsAction": "Needs action",
        "pickupRequests": "Pickups",
        "viewAbsences": "View leave requests",
        "viewAbsencesA11y": "{{name}}, view leave requests",
        "viewPickupA11y": "{{name}}, view pickup requests",
        "viewAbsencesNeedsInfoA11y": "{{name}}, the school is asking for more information on a leave request"
    },
    "medical": {
        "selectStudent": "Select a student to continue",
        "noteHint": "Share a temporary medical note about your child with the school. This is separate from permanent medical information in the profile.",
        "notePlaceholder": "e.g. recovering from illness, temporary medication, activity restriction…",
        "noteRequired": "Please enter a medical note.",
        "submit": "Submit note",
        "submitting": "Submitting…",
        "save": "Save changes",
        "saving": "Saving…",
        "edit": "Edit",
        "expandA11y": "{{name}}, expand medical note",
        "expandA11yNoName": "Expand medical note",
        "revoke": "Revoke",
        "revoking": "Revoking…",
        "revokeConfirmTitle": "Revoke medical note",
        "revokeConfirmMessage": "The school will no longer see this temporary note.",
        "revokeConfirmKeep": "Keep",
        "errorTitle": "Error",
        "submittedTitle": "Note submitted",
        "submittedBody": "Medical note for {{name}} was shared with the school.",
        "submitFailed": "Could not submit the medical note. Please try again.",
        "updatedTitle": "Note updated",
        "updatedBody": "Medical note for {{name}} was updated.",
        "updateFailed": "Could not update the medical note. Please try again.",
        "revokedTitle": "Note revoked",
        "revokedBody": "The medical note was revoked.",
        "revokeFailed": "Could not revoke the medical note."
    },
    "pickup": {
        "formHint": "This notifies school reception who will pick up your child. No further approval is required.",
        "date": "Pickup date",
        "startDate": "Start date",
        "endDate": "End date",
        "endDateOptional": "No end date",
        "days": "Days",
        "everyDay": "Every day",
        "selectedDays": "Selected days",
        "studentsRequired": "Select at least one student to create a pickup request.",
        "dateRequired": "Choose a pickup date so reception knows when to expect them.",
        "endDateRequired": "Choose when the weekly pickups should end.",
        "endBeforeStart": "The last pickup should be on or after the first one. Try adjusting the dates.",
        "daysRequired": "Pick at least one weekday for the weekly pickup.",
        "pickerName": "Person picking up",
        "pickerNamePlaceholder": "Full name",
        "pickerNameRequired": "Add the name of the person who will collect your child.",
        "relationship": "Relationship to student",
        "relationshipPlaceholder": "e.g. grandmother, family friend…",
        "relationshipRequired": "Let reception know how this person is related to your child.",
        "note": "Note",
        "notePlaceholder": "Anything reception should know…",
        "submit": "Notify reception",
        "submitting": "Submitting…",
        "expandA11yNoName": "Expand pickup on {{date}} by {{picker}}",
        "expandA11yRecurringNoName": "Expand weekly pickup {{days}} from {{from}} to {{to}} by {{picker}}",
        "revoke": "Revoke",
        "revoking": "Revoking…",
        "revokeConfirmTitle": "Revoke pickup",
        "revokeConfirmMessage": "Reception will be notified that this pickup is being revoked.",
        "revokeConfirmKeep": "Keep",
        "errorTitle": "One more thing",
        "submittedTitle": "Pickup submitted",
        "submittedBody": "Reception has been notified about pickup for {{name}}.",
        "submitFailed": "We couldn't send this just yet. Please try again.",
        "revokedTitle": "Pickup revoked",
        "revokedBody": "The pickup authorization was revoked.",
        "revokeFailed": "We couldn't revoke this just yet. Please try again.",
        "recurringWeekdays": "Every {{days}}"
    },
    "requests": {
        "title": "Requests",
        "actionNeededTitle": "Action needed",
        "periodRange": "{{from}} – {{to}}",
        "periodCurrentRange": "Current · {{range}}",
        "periodToday": "Today",
        "periodPreviousA11y": "Previous period",
        "periodNextA11y": "Next period",
        "periodTodayA11y": "Show current period",
        "emptyPeriod": "No leave requests in this period.",
        "awaitingSchoolTitle": "Waiting for approval",
        "filterAllStudents": "All students"
    },
    "family": {
        "title": "My family",
        "subtitle": "List of people linked to your school account."
    },
    "menu": {
        "settings": "Settings",
        "contactUs": "Contact us",
        "signOut": "Sign out",
        "title": "Menu"
    },
    "settings": {
        "security": "Security",
        "requireUnlock": "Require {{method}} to unlock",
        "biometricSystemDisabled": "{{method}} is turned off in system settings. Enable it there to secure the app.",
        "biometricOpenSettingsTitle": "{{method}} is off",
        "biometricOpenSettingsMessage": "Allow {{method}} for this app in system settings to use it for unlocking the app.",
        "version": "Version {{version}}",
        "activeSessions": "Your devices",
        "copyrightRights": "All rights reserved.",
        "copyright": "© {{year}} BASIS Educational Group CZ, s.r.o.",
        "notifications": {
            "title": "Notifications",
            "push": "Send notifications to this device",
            "systemDisabled": "Notifications are turned off in system settings. Enable them there to receive alerts from the school.",
            "openSettingsTitle": "Notifications are off",
            "openSettingsMessage": "Allow notifications for this app in system settings to receive alerts.",
            "openSettings": "Open Settings"
        },
        "display": {
            "title": "Appearance",
            "theme": "Theme",
            "themeFooter": "Choose light, dark, or follow your system appearance setting.",
            "theme-light": "Light",
            "theme-dark": "Dark",
            "theme-system": "Automatic",
            "language": "App language",
            "languageFooter": "App language. You can also change it in <settingsLink>Settings</settingsLink> on your device for this app.",
            "languageFooterWeb": "Default browser language can be changes in the browser settings.",
            "language-en": "English",
            "language-cs": "Čeština",
            "language-system": "System (default)",
            "language-browser": "Browser (default)"
        }
    },
    "activeSessions": {
        "title": "Your devices",
        "description": "These devices and browsers are currently signed into your account. Sign out of any you no longer need.",
        "sectionTitle": "Where you're signed in",
        "empty": "No active devices.",
        "loadError": "Could not load active devices.",
        "tryAgain": "Try again",
        "thisDevice": "This device",
        "signOut": "Sign out",
        "signingOut": "Signing out…",
        "signOutAll": "Sign out from all devices",
        "lastActive": "Last active {{relative}}",
        "lastActiveRecently": "Last active recently",
        "device": {
            "webBrowser": "Web browser",
            "iphone": "iPhone",
            "android": "Android device",
            "mobileApp": "Mobile app",
            "unknown": "Unknown device"
        },
        "revokeCurrentTitle": "Sign out of this device ?",
        "revokeCurrentMessage": "You will be signed out of the app on this device.",
        "revokeOtherTitle": "Sign out of this session ?",
        "revokeOtherMessage": "This will end the session on “{{device}}”.",
        "revokeAllTitle": "Sign out from all devices ?",
        "revokeAllMessage": "This will sign you out of all devices and browsers, including this one.",
        "revokeFailedTitle": "Could not sign out",
        "revokeAllFailedTitle": "Could not sign out from all devices",
        "revokeFailedFallback": "Please try again."
    },
    "contact": {
        "general": "General",
        "ourCampuses": "Our Campuses",
        "officeHours": "Office hours: {{hours}}",
        "website": "Website",
        "campusAccessibilityLabel": "{{name}} campus"
    },
    "leave": {
        "student": {
            "noStudents": "No linked students available.",
            "label": "Student",
            "labelMultiple": "Students"
        },
        "reasons": {
            "family_emergency": "Family emergency",
            "holiday": "Holiday",
            "illness": "Illness",
            "medical_appointment": "Medical appointment",
            "visa_residency_appointment": "Visa / Residency appointment",
            "extracurricular": "Extracurricular program"
        },
        "reasonDescriptions": {
            "family_emergency": "Up to one day of leave.",
            "holiday": "Multi-day leave.",
            "illness": "Part of a day or longer. Can be open-ended.",
            "medical_appointment": "Up to one day of leave.",
            "visa_residency_appointment": "Up to one day of leave.",
            "extracurricular": "Part of a day or longer. Can repeat."
        },
        "status": {
            "pending": "Pending",
            "approved": "Approved",
            "conditionally_approved": "Conditionally approved",
            "rejected": "Rejected",
            "cancelled": "Cancelled",
            "needs_info": "Needs info"
        },
        "selectReasonPlaceholder": "Select reason",
        "selectReason": "Select a reason for the leave request",
        "reason": "Reason",
        "close": "Close",
        "viewRequestA11y": "View leave request: {{reason}}, {{status}}, {{dates}}",
        "viewRequestA11yWithChild": "{{name}}, view leave request: {{reason}}, {{status}}, {{dates}}",
        "selectReasonA11y": "Select leave reason",
        "closeReasonPickerA11y": "Close reason picker",
        "start": "First day",
        "when": "Date",
        "partOfDayStart": "From",
        "partOfDayEnd": "To",
        "end": "Last day",
        "allDay": "All day",
        "absent": "Duration",
        "arrivesAt": "Coming late",
        "leavesAt": "Leaving early",
        "partOfDay": "Custom time",
        "recurringEnd": "Repeat until",
        "leavesAtTime": "Leaves at {{time}}",
        "arrivesAtTime": "Arrives at {{time}}",
        "weeklyOn": "Weekly ({{days}})",
        "timeRequired": "Please select a time, or choose All day.",
        "timeOrder": "Time from must be before time to.",
        "timeToRequiresDateTo": "Time to can only be set when an end date is selected.",
        "fromTime": "from {{time}}",
        "untilTime": "until {{time}}",
        "endDateRequired": "Please select an end date.",
        "endDateOptional": "No end date",
        "ongoing": "Ongoing",
        "notSet": "Not set",
        "daysRequired": "Pick at least one weekday for the weekly leave.",
        "additionalInformation": "Additional information",
        "additionalInformationPlaceholder": "Additional information for the school…",
        "submit": "Submit request",
        "submitting": "Submitting…",
        "errorTitle": "Error",
        "startDateRequired": "Please select a start date.",
        "dateOutsideSchoolYear": "Selected dates must be within the current school year ({{from}} – {{to}}).",
        "submittedTitle": "Request submitted",
        "submittedBody": "Leave request for {{name}} was sent to the school.",
        "submittedMixedBody": "Leave request for {{approvedNames}} was approved automatically. Leave request for {{pendingNames}} was sent to the school.",
        "autoApprovedTitle": "Request approved",
        "autoApprovedBody": "Leave request for {{name}} was approved automatically. The school has been informed.",
        "submitFailed": "Could not submit the leave request. Please try again.",
        "events": {
            "created": "Submitted",
            "auto_approved": "Auto-approved",
            "cancelled": "Cancelled",
            "approved": "Approved",
            "conditionally_approved": "Conditionally approved",
            "rejected": "Rejected",
            "info_requested": "Info requested",
            "resubmitted": "Resubmitted",
            "attachment_added": "Attachment added",
            "attachment_removed": "Attachment removed",
            "end_date_set": "End date set",
            "status_changed": "Status changed"
        },
        "history": "History",
        "actionNeeded": "Action needed",
        "schoolRequestTitle": "Message from the school",
        "infoRequestedDefault": "The school asked for additional information before this request can be reviewed.",
        "resubmitHint": "Add a note and/or upload a document, then resubmit for review.",
        "resubmitPlaceholder": "Add the requested information",
        "addInformation": "Add information",
        "resubmit": "Resubmit for review",
        "closeResubmitA11y": "Close resubmit form",
        "resubmitting": "Resubmitting…",
        "cancelRequest": "Cancel request",
        "cancelling": "Cancelling…",
        "cancelConfirmTitle": "Cancel request",
        "cancelConfirmMessage": "Are you sure you want to cancel this leave request?",
        "cancelConfirmKeep": "Keep",
        "cancelledTitle": "Cancelled",
        "cancelledBody": "The leave request was cancelled.",
        "cancelFailed": "Could not cancel the leave request.",
        "resubmittedTitle": "Resubmitted",
        "resubmittedBody": "The leave request was sent back for review.",
        "resubmitFailed": "Could not resubmit the leave request.",
        "setEndDate": "Set end date",
        "changeEndDate": "Change end date",
        "saveEndDate": "Save end date",
        "savingEndDate": "Saving…",
        "closeUpdateEndDateA11y": "Close end date form",
        "endDateBeforeStart": "The end date cannot be before the start date.",
        "endDateUpdatedTitle": "End date saved",
        "endDateUpdatedBody": "The end date was saved.",
        "updateEndDateFailed": "Could not update the end date.",
        "submittedAt": "Submitted {{date}}",
        "updatedAt": "Updated {{date}}",
        "attachments": {
            "label": "Attachments with documents for the school",
            "hint": "Attach PDF or image files (max. 5 files, 10 MB).",
            "add": "Add attachment",
            "addMenuHint": "Add from file or gallery.",
            "pickFile": "Choose file",
            "pickGallery": "Choose image from gallery",
            "working": "Updating attachments…",
            "unsupportedType": "Unsupported file type. Use PDF, JPG, PNG, or WEBP.",
            "tooLarge": "Each attachment must be 10 MB or smaller.",
            "uploadFailed": "Could not upload the attachment.",
            "uploadAfterCreateFailed": "The leave request was created, but some attachments could not be uploaded.",
            "remove": "Remove",
            "removeConfirmTitle": "Remove attachment",
            "removeConfirmMessage": "Remove {{name}} from this leave request?",
            "removedTitle": "Attachment removed",
            "removedBody": "The attachment was removed.",
            "removeFailed": "Could not remove the attachment.",
            "downloadFailed": "Could not download the attachment."
        },
        "dropzone": {
            "idle": "Drag files here or tap to browse",
            "dragging": "Drop files here",
            "duplicateOrLimit": "Selected files are already attached or the limit was reached.",
            "pickFailed": "Could not pick files. Please try again."
        }
    },
    "profile": {
        "roles": {
            "parent": "Parent",
            "parentPlural": "Parents",
            "student": "Student",
            "studentPlural": "Students",
            "other": "Other",
            "otherPlural": "Others"
        },
        "fields": {
            "first_name": "First name",
            "last_name": "Last name",
            "email": "Email",
            "phone": "Phone",
            "campusLevelClass": "Campus, level & class"
        },
        "fieldDescriptions": {
            "livingWithParent": "Indicate whether this child primarily lives with you. The school uses this for household records and emergency planning.",
            "legalCustody": "Confirm whether you hold legal custody or guardianship for this child. This affects who can make decisions and authorize school activities.",
            "pickupPermission": "Whether you are authorized to pick up this child from school. Only contacts with permission may collect students.",
            "citizenshipStatus": "The student's residency or citizenship status in the Czech Republic. The school needs this for administration and official reporting.",
            "allergies": "Select every allergy that applies to this student. Choose NONE if there are no known allergies. Staff rely on this for meals and first aid.",
            "dietaryRestrictions": "Select any dietary restrictions that apply to school meals and events. Choose NONE if there are no restrictions.",
            "healthInsuranceCompany": "The health insurance company covering this student. Used during school trips and medical emergencies.",
            "primaryContact": "Choose which parent is the primary contact for this student.",
            "invoiceRecipient": "Choose which parent should receive invoices for this student.",
            "pickupPermissionDays": "Select the weekdays when this student is allowed to leave school on their own without an adult pick-up."
        },
        "groups": {
            "contact": "Contact information",
            "familyPickup": "Family & pickup",
            "billing": "Billing",
            "student": "Student name",
            "school": "School information",
            "medical": "Medical information",
            "familyPermissions": "Family & permissions"
        },
        "familyProfiles": "Family profiles",
        "familyProfilesEmptyFooter": "No family profiles are linked yet. Contact the school if your account should be connected.",
        "loadingProfiles": "Loading profiles...",
        "error": {
            "noProfiles": "No profiles found.",
            "invalidProfileSelected": "Invalid profile selected.",
            "tryAgain": "Try again",
            "failedToLoadProfile": "Failed to load profile."
        },
        "placeholder": "Profile",
        "saveChanges": "Save changes",
        "savedTitle": "Changes saved",
        "savedBody": "Your profile changes have been saved.",
        "unsavedChangesTitle": "Discard changes?",
        "unsavedChangesMessage": "You have unsaved changes. If you leave now, they will be lost.",
        "unsavedChangesKeepEditing": "Keep editing",
        "unsavedChangesDiscard": "Discard",
        "badge": {
            "you": "You",
            "other": "Other",
            "parent": "Parent",
            "student": "Student"
        },
        "saveFailed": "Failed to save profile.",
        "title": {
            "parentProfile": "Parent profile",
            "studentProfile": "Student profile",
            "otherProfile": "Other profile",
            "description": {
                "parent": "Review and update your contact information and details required by the school.",
                "student": "Review and update the information you provided for this student to be used in the school system.",
                "other": "Review and update this contact’s details required by the school."
            },
            "descriptionReadOnly": {
                "parent": "Only this parent can edit their own profile. You can review the information below.",
                "student": "Only parents can edit this profile. You can review the information below."
            }
        }
    },
    "ui": {
        "selectOptions": "Select options",
        "selectOneOption": "Select an option",
        "selectOptionsMore": "{{visible}} +{{count}} more",
        "selectDate": "Select date",
        "closeDatePicker": "Close date picker",
        "selectTime": "Select time",
        "closeTimePicker": "Close time picker",
        "cancel": "Cancel",
        "done": "Done",
        "selectOneOrMoreOptions": "Select one or more options",
        "selectStudent": "Select at least one student to continue",
        "repeat": "Repeat",
        "oneOff": "Never",
        "daily": "Daily",
        "recurring": "Weekly",
        "daysOfWeek": "Weekdays",
        "weekdayShort": {
            "1": "Mon",
            "2": "Tue",
            "3": "Wed",
            "4": "Thu",
            "5": "Fri",
            "6": "Sat",
            "7": "Sun"
        },
        "weekday": {
            "1": "Monday",
            "2": "Tuesday",
            "3": "Wednesday",
            "4": "Thursday",
            "5": "Friday"
        },
        "optional": "Optional"
    },
    "absences": {
        "subtitle": "Review current leave requests for this student.",
        "currentTitle": "Current leave requests",
        "currentDescription": "Requests that need attention, plus approved leave that is ongoing or upcoming.",
        "newRequest": "Create leave request",
        "currentEmptyTitle": "No current leave requests",
        "currentEmptyDescription": "Create a leave request when you need to report or plan an absence."
    },
    "pickups": {
        "subtitle": "Manage pickup authorizations for this student. Parents and guardians may pick this student up without a pickup request.",
        "currentTitle": "Upcoming pickups",
        "newRequest": "Create pickup request",
        "currentEmptyTitle": "No upcoming pickups",
        "currentEmptyDescription": "Create a pickup request when someone else will collect this student from school.",
        "leaveDaysTitle": "Days without pickup",
        "leaveDays": "Leaves alone",
        "leaveDaysUnavailable": "No pickup days are available for this student.",
        "pickupRequired": "Pickup required"
    },
    "whatsNew": {
        "title": "A few things to make this easier",
        "continue": "Continue",
        "items": {
            "recurring": "Set leave and pick-up requests to repeat on regular days.",
            "times": "Specify a time on a leave request when it is not an all-day absence.",
            "replies": "Add a reply or an attachment when the school needs more information."
        }
    },
    "forceUpdate": {
        "title": "A new version is ready",
        "body": "There is a new version of the application which is required in order to work correctly. Please update the application {{store}}.",
        "update": "Update {{store}}",
        "storeAppStore": "in the App Store",
        "storeGooglePlay": "on Google Play"
    }
}
